export default __webpack_public_path__ + "static/Select-Dealer-4ba2dfc4500061a241aa119ea400e85c.webp";